// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Mobx
import { Observer } from "mobx-vue";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class ModelSelectionFilterModule extends ModuleBase {
  private get getFilterIdentifiers() {
    let filters = {};

    this.instance["filter"].slice().forEach((filter, index) => {
      filters[index] =
        filter.sparte +
        filter.flkGueltigkeiten
          .slice()
          .map((gueltigCategory) => gueltigCategory.flkGueltig)
          .sort()
          .join("");
    });

    return filters;
  }

  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }

  private handleSelectFilter(filter: any) {
    if (!filter) {
      this.$store.selectionFilter.selectedFilter = undefined;
    } else {
      let selectedFilter = {
        sparte: filter.sparte,
        gueltigkeiten: filter.flkGueltigkeiten.slice().map((x) => x.flkGueltig),
      };
      this.$store.selectionFilter.selectedFilter = selectedFilter;
    }
  }
}
